package site.shadadman.pages.worklog.bit24cash

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initBit24cashPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/bit24cash/bit24cash.md", FrontMatterElement.Builder { addScalar("title", "Bit24 Cash Worklog"); }))
}

@Page("/worklog/bit24cash/bit24cash")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun Bit24cashPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("bit24-cash") }) {
        org.jetbrains.compose.web.dom.Text("Bit24 Cash")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/bit24cash/sept92025Bit24FirstSprint") {
                org.jetbrains.compose.web.dom.Text("First Sprint")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/bit24cash/jan112026Bit24MigratingToKMP") {
                org.jetbrains.compose.web.dom.Text("Migrating to KMP")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/bit24cash/mar182026bit24AWarHasBegon") {
                org.jetbrains.compose.web.dom.Text("A War Has Begun")
            }
        }
    }
}
